import React, { Component } from 'react';
import { CheckCircle, Shield, Award, TrendingUp } from 'lucide-react';
const pillars = [{
  title: 'Contrato legal',
  description: 'Tu inversión protegida.'
}, {
  title: 'Entrega Responsable',
  description: 'Un equipo profesional, te acompaña en el proceso de entrega a la espera de tu aprobación.'
}, {
  title: 'Reportes diarios',
  description: 'Fotos e informes de avance en tu celular.'
}];
export function PillarsSection() {
  const handleWhatsApp = () => {
    // Track Lead event
    if (window.fbq) {
      window.fbq('track', 'Lead');
    }
    const message = encodeURIComponent('Hola, Quiero asesoría personalizada');
    window.open(`https://wa.me/573182434499?text=${message}`, '_blank');
  };
  return <section className="bg-white py-12 md:py-20" style={{
    contentVisibility: 'auto'
  }} data-id="element-147">
      <div className="max-w-[1280px] mx-auto px-4 md:px-6" data-id="element-148">
        <div className="text-center mb-8 md:mb-16" data-id="element-149">
          <h2 className="text-[26px] md:text-[40px] font-bold text-[#1A1A1A] mb-2 md:mb-4" style={{
          lineHeight: '1.2',
          letterSpacing: '-0.02em'
        }} data-id="element-150">
            Conoce los 3 pilares
          </h2>
          <p className="text-[15px] md:text-[17px] text-[#1A1A1A]/60 font-normal max-w-2xl mx-auto" style={{
          lineHeight: '1.6'
        }} data-id="element-151">
            Principios fundamentales que guían cada proyecto que emprendemos
          </p>
        </div>

        <div className="grid md:grid-cols-3 gap-4 md:gap-8 mb-6 md:mb-8" data-id="element-152">
          {pillars.map((pillar, index) => <div key={index} className="bg-white border-2 border-[#1A1A1A]/10 rounded-2xl md:rounded-3xl p-6 md:p-8 hover:border-[#E8621A]/30 transition-all hover:shadow-xl" data-id="element-153">
              <div className="flex items-start gap-3 md:gap-4" data-id="element-154">
                <div className="flex-shrink-0" data-id="element-155">
                  <CheckCircle className="w-6 h-6 md:w-8 md:h-8 text-[#10B981]" data-id="element-156" />
                </div>
                <div data-id="element-157">
                  <h3 className="text-[20px] md:text-[28px] font-semibold text-[#1A1A1A] mb-1 md:mb-2" style={{
                lineHeight: '1.3'
              }} data-id="element-158">
                    {pillar.title}
                  </h3>
                  <p className="text-[15px] md:text-[17px] text-[#1A1A1A]/70 font-normal" style={{
                lineHeight: '1.6'
              }} data-id="element-159">
                    {pillar.description}
                  </p>
                </div>
              </div>
            </div>)}
        </div>

        <div className="text-center mb-8 md:mb-12" data-id="element-160">
          <button onClick={handleWhatsApp} className="w-full md:w-auto bg-[#E8621A] text-white px-8 md:px-12 py-4 md:py-4 rounded-full font-bold uppercase text-[13px] md:text-[15px] hover:bg-[#d55515] transition-all shadow-xl hover:scale-105 min-h-[52px]" style={{
          lineHeight: '1',
          letterSpacing: '0.08em'
        }} data-id="element-161">
            Quiero asesoría personalizada
          </button>
        </div>

        <div className="grid md:grid-cols-3 gap-4 md:gap-6" data-id="element-162">
          {[{
          icon: Shield,
          value: '30+',
          label: 'Años de experiencia'
        }, {
          icon: Award,
          value: '100+',
          label: 'Proyectos Completados'
        }, {
          icon: TrendingUp,
          value: '98%',
          label: 'de aprobación de nuestros clientes'
        }].map((stat, i) => {
          const Icon = stat.icon;
          return <div key={i} className="bg-[#1A1A1A]/5 rounded-2xl md:rounded-3xl p-6 md:p-6 text-center" data-id="element-163">
                <Icon className="w-8 h-8 md:w-10 md:h-10 text-[#E8621A] mx-auto mb-2 md:mb-3" data-id="element-164" />
                <div className="text-3xl md:text-4xl font-black text-[#1A1A1A] mb-1 md:mb-2" data-id="element-165">
                  {stat.value}
                </div>
                <div className="text-[15px] md:text-[17px] text-[#1A1A1A]/60 font-normal" style={{
              lineHeight: '1.6'
            }} data-id="element-166">
                  {stat.label}
                </div>
              </div>;
        })}
        </div>
      </div>
    </section>;
}